import React from "react";
import "../components/CSS/Loading.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
function Loader() {
  return (
    <>
      <div className="loaderContrr">
        {" "}
        {/* <figure class="loader">
          <div class="car">
            <span class="body"></span>
            <span class="wheels"></span>
          </div>
          <div class="strikes">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </figure> */}
        <div style={{ width: 150, height: 150 }}>
          <DotLottieReact
            src="https://lottie.host/3beeb74c-0417-47bd-a6bd-e565595b2d59/MOEhBEPxfs.lottie"
            loop
            autoplay
          />
        </div>
      </div>
    </>
  );
}

export default Loader;
